module.exports = __webpack_public_path__ + "static/media/wheel-alignment.efbf2c95.svg";